// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"25":"53e6802b","117":"56174161"}[chunkId] + ".chunk.css";
};